import { t } from 'i18next'
import { NotificationReason } from '../../store/types/enums/NotificationReason'
import { AutocompleteFetch } from '../Autocomplete/AutocompleteFetch'
import { SxProps } from '@mui/material'

type AutocompleteNotificationReasonProps = {
  unmutedReasons: NotificationReason[]
  setUnmutedReasons: (option: NotificationReason[]) => void
  sxProps?: SxProps
}

const AutocompleteNotificationReason = ({
  unmutedReasons,
  setUnmutedReasons,
  sxProps,
}: AutocompleteNotificationReasonProps) => {
  const options = [
    NotificationReason.EMPLOYEE_VACATION_CREATED,
    NotificationReason.EMPLOYEE_UPCOMING_VACATION,
    NotificationReason.NEW_CANDIDATE_COMMENT,
  ]

  return (
    <AutocompleteFetch<NotificationReason>
      selectedItems={unmutedReasons}
      setSelectedItems={setUnmutedReasons}
      options={options}
      getLabel={option => t(`components.settingsDialog.notificationReasons.${option}`)}
      getId={option => option}
      labelTranslationKey="components.settingsDialog.notificationReason"
      width="60%"
      sxProps={sxProps}
    />
  )
}

export default AutocompleteNotificationReason
